import { render, staticRenderFns } from "./ModalDefault.vue?vue&type=template&id=ff1af86e&scoped=true&"
import script from "./ModalDefault.vue?vue&type=script&lang=js&"
export * from "./ModalDefault.vue?vue&type=script&lang=js&"
import style0 from "./ModalDefault.vue?vue&type=style&index=0&id=ff1af86e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1af86e",
  null
  
)

export default component.exports